import { render, staticRenderFns } from "./followupForm.vue?vue&type=template&id=3067d844&scoped=true&"
import script from "./followupForm.vue?vue&type=script&lang=ts&"
export * from "./followupForm.vue?vue&type=script&lang=ts&"
import style0 from "./followupForm.vue?vue&type=style&index=0&id=3067d844&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3067d844",
  null
  
)

export default component.exports